// Main.js
import React from 'react';
import { Container } from 'react-bootstrap';
import Necklace from '../assets/neckles.png';

export const Main = () => {
  return (
    <section id='sectionOne' style={{ position: 'relative', height: '100vh' }}>
      <Container>
        <div className='text-left'>
          <h2>BEST</h2>
        </div>
        <h1>JEWELLERY</h1>
        <div className='necklace'>
          <div className='circle'></div>
          <img src={Necklace} id='necklaceImg' />
        </div>
      </Container>
    </section>
  );
};
